// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"417":"b8b6b6d4","461":"10374c70","649":"5502c782"}[chunkId] + ".chunk.css";
};